import { APPLICANT_ATTENTION_ACTION_KEY } from '../../RentalPortalApplicantProfile.constants'
import { getIsApplicantDecisionSelfApproval } from '../../RentalPortalApplicantProfileTabOverview'

import {
  APPLICANT_ATTENTION_ACTION_DESTINATION,
  APPLICANT_ATTENTION_FULL_PAGE_ONLY_DESTINATIONS,
} from './useApplicantAttentionAction.constants'

export function getIsApplicantAttentionApproveAction(primaryAction) {
  return primaryAction?.key === APPLICANT_ATTENTION_ACTION_KEY.approve
}

export function getApplicantAttentionPrimaryAction({
  applicantData,
  currentUserId,
}) {
  const primaryAction = applicantData?.attention?.primary_action

  return getIsApplicantAttentionApproveAction(primaryAction) &&
    getIsApplicantDecisionSelfApproval({ applicantData, currentUserId })
    ? null
    : (primaryAction ?? null)
}

export function getApplicantAttentionActionState(primaryAction) {
  const destination = primaryAction
    ? (APPLICANT_ATTENTION_ACTION_DESTINATION[primaryAction.key] ?? null)
    : null

  return {
    destination,
    isDisabled: !destination,
    isFullPageOnly:
      APPLICANT_ATTENTION_FULL_PAGE_ONLY_DESTINATIONS.includes(destination),
  }
}
